import React, { useState, useEffect, useContext } from 'react';
import './manage-business-accounts.scss';
import { default as t } from '../../../../utils/i18n';
import { Table, Pagination } from 'rsuite';
import { AdminService } from '../../../../services';
import { UserContext } from '../../../../context';
import { ActionLink, CommonToaster } from '../../../atoms';
import { useHistory } from 'react-router-dom';
import { AddBm } from '../';
import { mapBusinessAccountData } from '../../../../utils/misc';

const ManageBusinessAccounts = props => {
  const { Column, HeaderCell, Cell } = Table;
  const [limit, setLimit] = React.useState(10);
  const [page, setPage] = React.useState(1);
  const [show, showstyle] = useState('');
  const [searchItem, setSearchItem] = useState('');
  const [businessManagers, setBusinessManagers] = useState('');
  const { user, setUser } = useContext(UserContext);
  const username = user?.username;
  const userAccessToken = user?.tokens?.accessToken?.jwtToken;
  const history = useHistory();
  const [addAccountsModal, setAddAccountsModal] = useState(false);
  const [bmDropdownOptions, setbmDropdownOptions] = useState([])
  const [toastDetails, setToastDetails] = useState({message: ''})
  const [toaster, setToaster] = useState(false);
  const [totalPages, setTotalPages] = useState(0);
   const handleChangeLimit = dataKey => {
    setPage(1);
    setLimit(dataKey);
    getBusinessManager(1, searchItem, dataKey, true);
  };

  const pageChange = page => {
    setPage(page);
    getBusinessManager(page, searchItem, limit, true);
  };
  const filterHandler = keyword => {
    if (!keyword.trim()) {
      showstyle('');
      setSearchItem('');
      getBusinessManager(1, '', undefined, true);
    } else {
      showstyle('show');
      setSearchItem(keyword);
      getBusinessManager(1, keyword, undefined, true);
    }
  };
  useEffect(() => {
    getBusinessManager(1, '', undefined, true);
  }, []);

  async function getBusinessManager(pageNo, searchKeyword, limit = 10, onBoardedOnly, getAll) {
    try {
      const bmResponse = await AdminService.businessAccountList(
        userAccessToken,
        username,
        limit,
        pageNo,
        searchKeyword,
        onBoardedOnly,
        getAll,
        user?.isSSO
      );
      const {businessAccountsList, pagination} = bmResponse?.data?.data
      const { res, options } = mapBusinessAccountData(businessAccountsList);

      if(!getAll){
        setBusinessManagers(res);
      }
      setTotalPages(pagination?.totalRecords);
      setbmDropdownOptions(options)
    } catch (error) {
      const dataCode = error?.data?.data?.code;
      if (dataCode) {
        //console.log(dataCode);
      }
    }
  }
  const getWidth = (value = 7) => {
    return window.innerWidth / value;
  };

  const getTime = value => {
    const date = new Date(value.lastAttemptedAt + value.syncInterval);
    return date.toString() !== 'Invalid Date' ? date.toLocaleString(): t('sync.date.time.not.available');
  };
  const StatusCell = ({ rowData, onChange, dataKey, ...props }) => (
    <Cell {...props} align="center">
      <div>
        {rowData?.metaInfo?.[dataKey]?.status === 'SUCCESS' ? (
          <i
            className="eva  eva-checkmark-circle-2 green"
            title={`${t('next.sync.at')} ${getTime(rowData?.metaInfo?.[dataKey])}`}
          ></i>
        ) : rowData?.metaInfo?.[dataKey]?.status === 'IN_PROGRESS' ? (
          <i
            className="eva  eva-alert-triangle yellow"
            title={`${t('next.sync.at')} ${getTime(rowData?.metaInfo?.[dataKey])}`}
          ></i>
        ) : (
          <i
            className="eva  eva-alert-triangle red"
            title={rowData?.metaInfo?.[dataKey]?.error?.details?.message}
          ></i>
        )}
      </div>
    </Cell>
  );

  const handleOnView = (e, rowData) => {
    history.push(`/account-details?accountId=${rowData?.businessId}`);
  };

  const handleOnAdd = () => {
    getBusinessManager(1, '',  undefined, true);
  };
  const onClikAdd = () => {
    getBusinessManager(1, '', undefined, undefined, true);
    setAddAccountsModal(true);
  };

  const toastDetailsFn = (toastDetails) =>{
    setToaster(true)
    setToastDetails(toastDetails)
    clearToaster()
  }

    const clearToaster = () => {
    setTimeout(() => {
      console.log('clear called');
      setToaster(false);
    }, 5000);
  };

  return (
    <section>
      <CommonToaster toaster={toaster} message={toastDetails} />
      <div className="manage_business_accounts">
        <div className="import-campaigns-container-details">
          <div className="topContainer">
            <h3>{t('Manage Business Accounts')}</h3>
            <span>{t('Add a new Business Manager from OneSocial or update token settings for an existing one.')}</span>
            <br></br>
          </div>
          <div className="add-bm">
            <button className="step-back" onClick={onClikAdd}>
              {t('Add / Update Business Manager')}
            </button>
          </div>

          <div className="search-section-container search_align_end ">
            <h3>{t('admin.dashboard.businessAccounts')}</h3>

            <div className="search-field">
              <i className="eva eva-search-outline search-icon"></i>
              <input
                type="text"
                name="search"
                placeholder={t('admin.dashboard.search')}
                onChange={e => filterHandler(e.target.value, e)}
                value={searchItem}
                autoComplete="off"
              />
              <button
                type="button"
                className={`clear-btn ${show}`}
                onClick={e => filterHandler('')}
              >
                <i className="eva eva-close-outline clear-icon"></i>
              </button>
            </div>
          </div>
          <div>
            <Table
              autoHeight
              data={businessManagers}
              bordered
              className="admin-table"
            >
              <Column width={getWidth(5)}>
                <HeaderCell>{t('admin.dashboard.businessId')}</HeaderCell>
                <Cell dataKey="businessId" />
              </Column>

              <Column width={getWidth(5)}>
                <HeaderCell>{t('admin.dashboard.businessName')}</HeaderCell>
                <Cell dataKey="businessName" />
              </Column>
              <Column width={getWidth(5)}>
                <HeaderCell>{'Last Syndicated from OneSocial at'}</HeaderCell>
                <Cell dataKey="lastUpdated" />
              </Column>
            </Table>
          </div>
          <div className="pagination-div">
            <span>{t('reports.per.page')}</span>
            <Pagination
              prev
              next
              first
              last
              ellipsis
              boundaryLinks
              maxButtons={3}
              layout={['-', 'limit', '|', 'pager']}
              total={totalPages}
              limitOptions={[10, 15]}
              limit={limit}
              activePage={page}
              onChangePage={page => {
                pageChange(page);
              }}
              onChangeLimit={handleChangeLimit}
            />
          </div>
          <div className="noted_symbols">
            <span className="align_item">
              <i className="eva  eva-checkmark-circle-2 green"></i> {t('bm.last.success')}
            </span>
            <span className="align_item border_align">
              <i className="eva  eva-alert-triangle yellow"></i> {t('bm.last.warn')}
            </span>
            <span className="align_item border_align">
              <i className="eva  eva-alert-triangle red"></i> {t('bm.last.error')}
            </span>
          </div>
        </div>
      </div>
      {addAccountsModal && (
        <AddBm
          addAccountsModal={addAccountsModal}
          setAddAccountsModal={setAddAccountsModal}
          handleOnAdd={handleOnAdd}
          bmOptions={bmDropdownOptions}
          toasterDetails={toastDetailsFn}
        />
      )}
    </section>
    // </div>
  );
};

export default ManageBusinessAccounts;
